import { getActivityLogs } from "../../../../api";
import { useAuth } from "../../../../contexts/AuthContext";
import moment from "moment";
import { Link } from "react-router-dom";
import Loader from "../../../../components/Loader";
import styled from "styled-components";
import { useQuery } from "@tanstack/react-query";
import { nanoid } from "nanoid";

const MyRecentActivity = styled(({ className }) => {
  const { currentUser } = useAuth();

  const { data } = useQuery({
    queryKey: [
      "activity:list",
      {
        user_id: currentUser.user_id,
        pageSize: 10,
      },
    ],
    queryFn: () =>
      getActivityLogs({
        user_id: currentUser.user_id,
        pageSize: 10,
      }),
  });

  if (!data) return <Loader />;

  if (data.length === 0)
    return <div style={{ textAlign: "center" }}>No Recent Activity</div>;

  return (
    <div className={className}>
      {data.map((activity) => (
        <ActivityLog key={nanoid()} activity={activity} />
      ))}
    </div>
  );
})`
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
  height: calc(100% - 50px);
  flex: 1 1 auto;
  padding: 0px 10px;
`;

const ActivityLog = styled(({ className, activity }) => {
  return (
    <Link
      to={activity.case_id > 0 ? `/cases/${activity.case_id}/activity` : "#"}
    >
      <div className={className} title="Go to Case">
        <div className="task-content">
          <div className="task-name" title={activity.activity}>
            {activity.activity}
          </div>
          <div className="case-number">
            {activity.case_number || "Admin Log"}
          </div>
        </div>
        <div>
          <div className="due-date">{moment(activity.timestamp).fromNow()}</div>
        </div>
      </div>
    </Link>
  );
})`
  cursor: pointer;
  background-color: transparent;
  border: ${(props) => `1px solid ${props.theme.palette.divider}`};
  border-radius: 5px;
  padding: 5px 10px;
  transition: all 0.2s ease-in-out;
  display: flex;
  justify-content: space-between;
  align-items: center;
  user-select: none;

  &:hover {
    border: ${(props) => `1px solid ${props.theme.palette.primary.main}`};
    cursor: pointer;
  }
  .task-content {
    max-width: 200px;
  }
  .task-name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .case-number {
    color: ${(props) => props.theme.palette.text.secondary};
    font-size: 10px;
  }
  .due-date {
    color: ${(props) => props.theme.palette.text.secondary};
    font-size: 10px;
  }
`;

export default MyRecentActivity;
